import React from 'react';
import { Link } from 'react-router-dom';

type PendingApprovalCardProps = {
  to: string;
  title: string;
  subtitle: string;
  pillLabel: string;
  detail: string;
  amountLabel: string;
  requestedLabel: string;
  /** Actions under the link, such as Dismiss for today. */
  children?: React.ReactNode;
};

/** One quote waiting on the viewer in Home › Approvals; the whole card links to where it's approved. */
export default function PendingApprovalCard({
  to,
  title,
  subtitle,
  pillLabel,
  detail,
  amountLabel,
  requestedLabel,
  children,
}: PendingApprovalCardProps) {
  return (
    <div
      className="pending-approval-card"
      style={{
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '0.9rem 1rem',
        background: 'var(--surface-soft)',
        display: 'grid',
        gap: '0.35rem',
      }}
    >
      <Link
        to={to}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'grid',
          gap: '0.35rem',
        }}
      >
        <div className="flex between center" style={{ gap: '0.75rem', flexWrap: 'wrap' }}>
          <div style={{ minWidth: 0 }}>
            <div className="text-sm" style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {title}
            </div>
            <div className="text-xs fg-muted">{subtitle}</div>
          </div>
          <span className="pill micro" style={{ background: 'var(--warn-bg)', color: 'var(--warn-fg)' }}>
            {pillLabel}
          </span>
        </div>
        <div className="text-xs fg-muted" style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', flexWrap: 'wrap' }}>
          <span>{detail}</span>
          <span>{amountLabel}</span>
        </div>
        <div className="text-xxs fg-muted">{requestedLabel}</div>
      </Link>
      {children ? <div style={{ marginTop: 4 }}>{children}</div> : null}
    </div>
  );
}
